import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  spacing: 4,
  typography: {
    fontFamily: '"Montserrat", sans-serif',
  },
  shape: {
    borderRadius: 2,
  },
  palette: {
    primary: {
      main: '#1050b3',
      light: '#F8FBFF',
    },
    secondary: {
      main: '#FFFFFF',
    },
    text: {
      primary: '#11202D',
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
    background: {
      default: '#F8FBFF',
    },
  },
});

export default theme;
